import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import styled from 'styled-components';
import { Breadcrumbs, Divider, Fade, IconButton, Link, Menu, MenuItem } from '@material-ui/core';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import { Home } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import userManager from 'lib/auth/UserManager';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex-grow: 1;
	text-transform: uppercase;
	/* min-height: 8rem; */
	padding: 1rem;
	font-size: 3rem;
	font-weight: 700;
	background-color: ${(props) => props.theme.header.colors.background};
	color: ${(props) => props.theme.header.colors.foreground};
`;
const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		marginBottom: '1rem'
	},
	menuButton: {
		color: theme.palette.text.secondary
	},
	title: {
		flexGrow: 1
	},
	crumbs: {
		backgroundColor: theme.palette.primary.dark,
		color: theme.palette.primary.contrastText,
		marginBottom: '1rem',
		padding: '0.5rem'
	}
}));

export const Header = () => {
	const history = useHistory<string>();
	const classes = useStyles();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const onCloseClick = () => {
		setAnchorEl(null);
	};
	const onHomeClick = () => {
		history.push('/');
		onCloseClick();
	};
	const onLogout = () => {
		userManager.signoutRedirect().then((_) => history.push('/#'));
	};
	return (
		<AppBar className={classes.root} position="static">
			<Toolbar>
				<IconButton onClick={handleClick}>
					<MenuIcon className={classes.menuButton} />
				</IconButton>
				<Menu id="fade-menu" anchorEl={anchorEl} keepMounted open={open} onClose={onCloseClick} TransitionComponent={Fade}>
					<MenuItem onClick={onHomeClick}>Home</MenuItem>
					<Divider></Divider>
					<MenuItem onClick={onLogout}>Logout</MenuItem>
				</Menu>
				<Typography className={classes.title} variant="h5" component="h5">
					Mailroom
				</Typography>
			</Toolbar>
		</AppBar>
	);
};
